/*jshint esversion: 6 */
import React from 'react';
import { connect } from 'react-redux';
import { LinkpageActions } from 'app/redux/actions.js';

function mapStateToProps(state) {
    return ({
        linkpages: state.linkpages
    });
}

function mapDispatchToProps(dispatch) {
    return {
        fetchLinkpageSettings: (id) => dispatch(LinkpageActions.fetchLinkpageSettings(id)),
        updateLinkpageSettings: (id, changes) => dispatch(LinkpageActions.updateLinkpageSettings(id, changes))
    };
}

export default function LinkpageProvider(Component) {
    class LinkpageProvider extends React.Component {
        render() {
            return (<Component {...this.props}/>);
        }
    }
    LinkpageProvider.displayName = "LinkpageProvider";
    return connect(mapStateToProps, mapDispatchToProps)(LinkpageProvider);
}
